import React from 'react';
import '../scss/components/_cta-button.scss'

const CtaButton = props => (
    <div className="buttonContent">
        <center><a className="button" rel="noopener noreferrer" target="_blank" href={props.link}>{props.text}</a></center>
    </div>
);

export default CtaButton;